import ajaxService, { AjaxError } from "AjaxService";
import global from "Global";
import { joinUri } from "UriUtils";

class AutoLogonService {
  async redirectWithAutologinAsync(destinationUrl: string, openInSameWindow: boolean): Promise<void> {
    if (!destinationUrl) {
      throw new Error("destinationUrl must not be empty");
    }
    const autoLoginUrl = joinUri(global.serviceUri, "autologon/url?baseUrl=" + encodeURIComponent(destinationUrl));

    try {
      const url = await ajaxService.postAsync<string | undefined>(autoLoginUrl);

      if (!url) {
        openUrl(destinationUrl, openInSameWindow);
      } else {
        openUrl(url, openInSameWindow);
      }
    } catch (error) {
      if (!(error instanceof AjaxError)) {
        throw error;
      }
      openUrl(destinationUrl, openInSameWindow);
    }
  }
}

function openUrl(url: string, openInSameWindow: boolean): void {
  /*! SuppressStringValidation _self opens link in current page */
  openInSameWindow ? window.open(url, "_self") : window.open(url);
}

export default new AutoLogonService();
